export const PROPERTY_PATH_MAP = {
  headOfHousehold: {
    path: 'headOfHousehold',
    dataType: 'string',
  },
  unit: {
    path: 'unit',
    dataType: 'string',
  },
  hudUnitNumber: {
    path: 'hudUnitNumber',
    dataType: 'string',
  },
  bedsBaths: {
    path: 'bedsBaths',
    dataType: 'string',
  },
  contractRent: {
    path: 'contractRent',
    dataType: 'number',
  },
  utilityAllowance: {
    path: 'utilityAllowance',
    dataType: 'number',
  },
  grossRent: {
    path: 'grossRent',
    dataType: 'number',
  },
  incomeCode: {
    path: 'incomeCode',
    dataType: 'string',
  },
  turnoverCode: {
    path: 'turnoverCode',
    dataType: 'string',
  },
  turnoverMonthDay: {
    path: 'turnoverMonthDay',
    dataType: 'date',
  },
  nextRecertDate: {
    path: 'nextRecertDate',
    dataType: 'date',
  },
  dateFirstRecertReminderNoticeSent: {
    path: 'dateFirstRecertReminderNoticeSent',
    dataType: 'date',
  },
  changeCode: {
    path: 'changeCode',
    dataType: 'string',
  },
  requestedAmount: {
    path: 'requestedAmount',
    dataType: 'number',
  },
  approvedAmount: {
    path: 'approvedAmount',
    dataType: 'number',
  },
};
